import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';
import { Action, Dispatch, bindActionCreators } from 'redux';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import * as lessonAssignmentActions from 'common.components/lesson-view.assignment/actions';
import { SIDE_PANEL_MODE } from 'common.components/lesson-view.side-panel/side-panel-mode';
import * as actions from 'common.components/lesson-view.store/actions';

import * as selectors from '../selectors';

import './side-panel__assign-header.scss';

interface StoreProps {
    mode: SIDE_PANEL_MODE;
}

interface DispatchProps {
    setShouldShowAssignmentSettings: typeof actions.setShouldShowAssignmentSettings;
    setAssignmentToDefault: typeof lessonAssignmentActions.setToDefault;
}

export interface Props extends StoreProps, DispatchProps {}

export const SidePanelAssignHeaderDesktop = (props: Props) => {
    const { mode, setShouldShowAssignmentSettings, setAssignmentToDefault } = props;

    const onAssignHeaderBackClick = () => {
        setShouldShowAssignmentSettings(false);
        setAssignmentToDefault();
    };

    return (
        <>
            {mode === SIDE_PANEL_MODE.REASSIGNMENT && (
                <div className="side-panel__assign-header-back" {...accessibleClick(onAssignHeaderBackClick)}>
                    <Text id="lessonView.sidePanel.reassignment.back" />
                </div>
            )}
            <Text
                id={
                    mode === SIDE_PANEL_MODE.ASSIGNMENT
                        ? 'assignLessonModal.title'
                        : 'lessonView.sidePanel.reassignment.title'
                }
                size={Text.SIZE.XL}
                weight={Text.WEIGHT.M}
            />
        </>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        mode: selectors.getSidePanelMode(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            setShouldShowAssignmentSettings: actions.setShouldShowAssignmentSettings,
            setAssignmentToDefault: lessonAssignmentActions.setToDefault,
        },
        dispatch
    );
};

const connected = connect(mapStateToProps, mapDispatchToProps)(SidePanelAssignHeaderDesktop);
connected.displayName = 'AssignHeaderDesktop';

export default connected;
